<div class="main_content px-3 position-relative">
	<div class="container-fluid py-3">
		<div class="row">
			<div class="col-lg-12 col-md-12">
				<div class="white_box shadow p-3">
					<!-- Table -->

					<ul class="nav nav-tabs">
						<li class="nav-item">
							<a class="nav-link" [ngClass]="{'active':selMenu=='quest'}" aria-current="page"
								(click)="selectMenu('quest')">Quest</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" [ngClass]="{'active':selMenu=='sendCustomQuestToMember'}"
								(click)="selectMenu('sendCustomQuestToMember')">Send custom Quest To Member</a>
						</li>
					</ul>

					<!-- Cards -->
					<section class="mt-3" *ngIf="selMenu == 'quest'">
						<section class="d-flex justify-content-between" style="gap: 5px;">
							<button type="submit" class="btn btn-dark mb-2" (click)="add(AddQuest)"><i
									aria-hidden="true" class="fa fa-plus-circle"></i> Create New Quest</button>
						</section>
						<table class="table table-striped bg-white">
							<thead>
								<tr>

									<th scope="col" sortable="phone" (click)="onSort($event)">#</th>
									<th scope="col" sortable="level" (sort)="onSort($event)">Quest</th>
									<th scope="col" sortable="level" (sort)="onSort($event)">Level Assign</th>
									<th scope="col" sortable="level" (sort)="onSort($event)">Key</th>
									<th scope="col" sortable="level" (sort)="onSort($event)">Action</th>

								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let member of questList; index as i">
									<tr *ngIf="members.length > 0">
										<th scope="row">{{i + 1}}</th>
										<td [width]="500">{{member?.description}}</td>
										<td>
											<ngx-slider [(value)]="member.minLevel" [(highValue)]="member.maxLevel"
												[options]="optionsQuestLevel"></ngx-slider>
										</td>
										<td>{{member?.questKey}}</td>
										<td class="text-right">
											<section class="d-flex justify-content-center">
												<button class="btn btn-info" (click)="saveLevel(member)">
													<i class="fa fa-pencil" aria-hidden="true"></i>
													Save Level
												</button>
												<button class="btn btn-info  ml-2" (click)="add(AddQuest,member)">
													<i class="fa fa-pencil" aria-hidden="true"></i>
													Edit Quest
												</button>

												<button class="btn btn-danger  ml-2"
													(click)="deleteQuest(member?.questId)">
													<i class="fa fa-trash" aria-hidden="true"></i> Delete
												</button>
											</section>
										</td>
									</tr>
								</ng-container>

								<tr *ngIf="members.length == 0">
									<td colspan="12" style="text-align: center;">No Data</td>
								</tr>
							</tbody>
						</table>
					</section>

					<section class="mt-3" *ngIf="selMenu == 'sendCustomQuestToMember'">
						<ul class="nav nav-tabs">
							<li class="nav-item">
								<a class="nav-link" [ngClass]="{'active':selSubMenu=='create'}" aria-current="page"
									(click)="selectSubMenu('create')">Create</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" [ngClass]="{'active':selSubMenu=='completed'}"
									(click)="selectSubMenu('completed')">Completed</a>
							</li>
						</ul>

						<!-- create -->
						<section class="mt-5" *ngIf="selSubMenu == 'create'">
							<section class="row flex justify-content-between ml-2 mr-2 mb-4">
								<div style="width: 80%;">
									<ngx-slider [(value)]="value" [(highValue)]="highValue" [options]="options"
										(userChange)="onLevelChange()"></ngx-slider>
								</div>
								<button type="button" class="btn btn-primary mr-3 mb-2"
									(click)="selectTypeOfQuests(reportsPopup)">
									Send Quests <i class="fa fa-arrow-right" aria-hidden="true"></i>
								</button>
							</section>
							<table class="table table-striped bg-white">
								<thead>
									<tr>
										<th scope="col"><input type="checkbox" value="" id="flexCheckDefault" /> Select
											All</th>
										<th scope="col" sortable="phone" (click)="onSort($event)">Member</th>
										<th scope="col" sortable="level" (sort)="onSort($event)">Level</th>
										<th scope="col" sortable="totalActiveTime" (sort)="onSort($event)">Total Active
											time</th>
										<th scope="col" sortable="noOfTimeLogin" (sort)="onSort($event)">No. of Time
											Login</th>
										<th scope="col" sortable="noOfReferrals" (sort)="onSort($event)">No. of
											Referrals</th>
										<th scope="col" sortable="noSuggestions" (sort)="onSort($event)">No. Suggestions
										</th>
										<th scope="col" sortable="noReports" (sort)="onSort($event)">No. Reports</th>
										<th scope="col" sortable="noForumPosts" (sort)="onSort($event)">No. Forum Posts
										</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let member of members; index as i">
										<tr *ngIf="members.length > 0">
											<td>
												<input type="checkbox" value="" id="flexCheckDefault"
													(click)="selectMember(member,$event.target.checked)"
													[value]="member?.check" />
											</td>
											<td><a style="color: #009dff;">{{member?.phone}}</a></td>
											<td>{{member?.level || 0}}</td>
											<td>{{member?.totalSessionTimeInHr + ' Hours'}}</td>
											<td>{{member?.noOfTimeLogin}}</td>
											<td>{{member?.noOfReferrals || 0 }}</td>
											<td>{{member?.suggestions || 0 }}</td>
											<td>{{member?.reports || 0 }}</td>
											<td>{{member?.noForumPosts || 0 }}</td>
										</tr>
									</ng-container>

									<tr *ngIf="members.length == 0">
										<td colspan="12" style="text-align: center;">No Data</td>
									</tr>
								</tbody>
							</table>

							<div class="d-flex justify-content-between p-2">
								<ngb-pagination [collectionSize]="totalMembers.length" [(page)]="page"
									[pageSize]="pageSize" (pageChange)="nextPage()">
								</ngb-pagination>

								<select class="form-select" style="width: auto;" [(ngModel)]="pageSize"
									(ngModelChange)="nextPage()">
									<option [ngValue]="10">10 items per page</option>
									<option [ngValue]="20">20 items per page</option>
									<option [ngValue]="30">30 items per page</option>
								</select>
							</div>
						</section>
						<!-- create -->

						<!-- completed -->
						<section class="mt-5" *ngIf="selSubMenu == 'completed'">
							<div class="mb-3 row mt-5">
								<!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
								<div class="col-xs-3 col-sm-auto">
									<div class="input-group">
										<input id="table-filtering-search" class="form-control"
											(keyup)="searchQuestBaseOnMember($event.target.value,'phone')" type="text"
											placeholder="Search member" />
									</div>
								</div>
								<div class="col-2">
									<div class="input-group">
										<input type="text" class="form-control" [owlDateTimeTrigger]="dt3"
											[owlDateTime]="dt3" [formControl]="searchDate" [selectMode]="'range'"
											placeholder="Search Created Date" />
										<owl-date-time [pickerType]="'calendar'"
											(afterPickerClosed)="searchByDate(searchDate.value)" #dt3></owl-date-time>
										<!-- <button
											type="button"
											*ngIf="searchDate.value"
											class="btn bg-transparent"
											style="margin-left: -40px; z-index: 100;"
										>
											<i class="fa fa-times"></i>
										</button> -->
									</div>
								</div>
								<div class="col-xs-3 col-sm-auto">
									<div class="form-group">
										<select class="form-control"
											(change)="searchQuestBaseOnMember($event.target.value,'status')"
											style="height: calc(2.1rem + 2px);">
											<option>Select Quests Status</option>
											<option value="1">Completed</option>
											<option value="0">Pending</option>
										</select>
									</div>
								</div>

								<div class="col-xs-3 col-sm-auto">
									<div class="form-group">
										<select class="form-control"
											(change)="searchQuestBaseOnMember($event.target.value,'type')"
											style="height: calc(2.1rem + 2px);">
											<option>Select Quests Type</option>
											<option>Basic</option>
											<option>Pending</option>
										</select>
									</div>
								</div>
							</div>
							<!-- Table -->
							<table class="table table-striped bg-white">
								<thead>
									<tr>
										<th scope="col"><input type="checkbox" value="" id="flexCheckDefault" /> #</th>
										<th scope="col" sortable="phone" (click)="onSort($event)">Member</th>
										<th scope="col" sortable="phone" (click)="onSort($event)">Message</th>
										<th scope="col" sortable="level" (sort)="onSort($event)">Quests Type</th>
										<th scope="col" sortable="level" (sort)="onSort($event)">Quests status</th>
										<th scope="col" sortable="level" (sort)="onSort($event)">Created On</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let quest of quests; index as i">
										<tr *ngIf="quests.length > 0">
											<th scope="row">{{ i + 1 }}</th>
											<td><a style="color: #009dff;">{{quest?.appUser?.phone}}</a></td>
											<td>{{quest.message }}</td>
											<td>{{quest.type | titlecase}}</td>
											<td>
												<span class="quest-status"
													[ngStyle]="{'background-color': (quest?.status == 0) ? 'lightcyan' : (quest?.status == 1) ? '#c8ffcc' :  (quest?.status == 2 || quest?.status == 4 ) ? '#ffb0b0' : '#f7f9d4' }">{{(questStatus[quest.status]
													|| '' )| titlecase}}</span>
											</td>
											<td>{{quest.createdAt |date:"dd/MM/yyyy"}}</td>
										</tr>
									</ng-container>

									<tr *ngIf="quests.length == 0">
										<td colspan="12" style="text-align: center;">No Data</td>
									</tr>
								</tbody>
							</table>

							<div class="d-flex justify-content-between p-2">
								<ngb-pagination [collectionSize]="totalMembers.length" [(page)]="page"
									[pageSize]="pageSize" (pageChange)="nextPage()">
								</ngb-pagination>

								<select class="form-select" style="width: auto;" [(ngModel)]="pageSize"
									(ngModelChange)="nextPage()">
									<option [ngValue]="10">10 items per page</option>
									<option [ngValue]="20">20 items per page</option>
									<option [ngValue]="30">30 items per page</option>
								</select>
							</div>
							<!-- Table -->
						</section>
					</section>

				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #reportsPopup let-modal>
	<div class="modal-body">
		<div class="quest-popup-header">
			<h2>Quests</h2>
			<img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
		</div>
		<div class="referral-link">
			<h5 class="mt-3 ml-4 fw-bolder">
				Select Type of Quest:
			</h5>

			<section class="ml-4 mr-4 mb-4 mt-2">
				<ng-container *ngFor="let q of questsOption">
					<div class="form-group">
						<label>
							<input type="radio" name="flexRadioDefault" id="flexRadioDefault1"
								(click)="selectQuest(q.name)" /> Like {{q.name | titlecase}} :</label>
						<section>
							<div class="card ml-3" style="width: 25rem;">
								<div class="card-body">
									<span class="quest-tag">{{q.type | titlecase}}</span>
									<span class="quest"></span>
									<p class="card-text mt-2">{{q.message}}</p>
									<p class="card-text">Expiry : {{q.expiry ? q.expiry + 'days' : 'No Expiry'}}</p>
								</div>
							</div>
						</section>
					</div>
				</ng-container>
			</section>

			<section class="ml-4 mr-4 mb-4 mt-2">
				<div class="form-group">
					<label> <input type="radio" name="flexRadioDefault" id="flexRadioDefault1"
							(click)="selectQuest('custom')" /> Custom Quests :</label>
					<textarea style="width: 25rem;" class="form-control ml-3" placeholder="Enter details"
						id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="customQuestMessage"
						rows="6"></textarea>
				</div>
			</section>
			<div class="mt-5">
				<div class="flex text-center">
					<button type="button" class="btn btn-primary mr-3 mb-2" (click)="sendQuests()">
						Send <i class="fa fa-paper-plane" aria-hidden="true"></i>
					</button>
					<!-- <a class="confirm_button" (click)="copyReferralLink()">
            <img loading="lazy" src="../../../../assets/images/copy-icon.svg" alt="img">
            Copy</a> -->
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #AddQuest let-modal>
	<div class="modal-body">
		<div class="add_cattt d-flex justify-content-between">
			<h2>Add Quest</h2>
			<img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
		</div>
		<form [formGroup]="form">
			<div class="referral-link">
				<section class="m-4">

					<div class="form-group">
						<textarea type="text" [rows]="4" class="form-control" placeholder="Enter Quest Description"
							maxlength="500" formControlName="description"></textarea>
					</div>

					<div class="form-group col-12">
						<label>Key for Quest </label>
						<input type="text"  placeholder="Enter KEY" class="form-control" formControlName="key">
					</div>

				</section>
				<div class="mt-4">
					<div class="cart_btn">
						<button class="com_btn add-review-btn px-2" (click)="addQuest()">Save <i class="fa fa-save"
								aria-hidden="true"></i></button>
					</div>
				</div>
			</div>
		</form>
	</div>
</ng-template>